import React from 'react'
import classes from './Unauthorized.module.scss'

const Unauthorized = () => (
  <div className={classes.root}>
    <p className={classes.title}>Access Denied</p>

    <p>
      You do not have sufficient permission to view this page. Please contact
      your administrator for more details.
    </p>
  </div>
)

export default Unauthorized
